let trailCount;
let trailPosition = 0;
let trailTarget = 0;
let trailFrame = 0;
const trailPositionFor = count => Math.min(1, Math.max(0, (count - 1) / 2));
function paintTrails() {
  document.querySelectorAll('talamora-free-shipping').forEach(element => element.paint());
}
function setTrailCount(count) {
  if (!Number.isFinite(count) || count < 0 || count === trailCount) return;
  const from = trailPosition;
  trailCount = count;
  trailTarget = trailPositionFor(count);
  cancelAnimationFrame(trailFrame);
  const start = performance.now();
  const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 1200;
  function tick(now) {
    const fraction = duration ? Math.min(1, (now - start) / duration) : 1;
    const eased = fraction;
    trailPosition = from + (trailTarget - from) * eased;
    if (fraction === 1) trailPosition = trailTarget;
    paintTrails();
    trailFrame = fraction < 1 ? requestAnimationFrame(tick) : 0;
  }
  tick(start);
}
class TalamoraFreeShipping extends HTMLElement {
  connectedCallback() {
    if (trailCount === undefined) {
      trailCount = Number(this.dataset.count) || 0;
      trailPosition = trailTarget = trailPositionFor(trailCount);
    }
    this.paint();
  }
  paint() {
    const remaining = Math.max(0, 3 - trailCount);
    const moving = Math.abs(trailPosition - trailTarget) > 0.0001;
    const message = this.querySelector('[data-shipping-message]');
    const progress = this.querySelector('progress');
    if (!message || !progress) return;
    const text = remaining === 0 ? this.dataset.unlocked : remaining === 1 ? this.dataset.one : this.dataset.many.replace('[count]', String(remaining));
    if (message.textContent !== text) message.textContent = text;
    this.dataset.count = String(trailCount);
    progress.value = Math.min(3, trailCount);
    this.style.setProperty('--trail-progress', String(trailPosition));
    this.style.setProperty('--trail-duration', '0ms');
    this.classList.toggle('tm-moving', moving);
    this.classList.toggle('tm-shipping--unlocked', remaining === 0);
    this.classList.toggle('tm-arrived', remaining === 0 && !moving);
  }
}
if (!customElements.get('talamora-free-shipping')) customElements.define('talamora-free-shipping', TalamoraFreeShipping);
let shippingRequest = 0;
document.addEventListener('cart:update', async event => {
  if (event.detail?.data?.didError) return;
  const current = ++shippingRequest;
  let count = event.detail?.resource?.item_count;
  if (!Number.isFinite(count)) {
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
      if (!response.ok) return;
      count = (await response.json()).item_count;
    } catch { return; }
  }
  if (current !== shippingRequest) return;
  setTrailCount(count);
});
